import { render, staticRenderFns } from "./TextAlignPopover.vue?vue&type=template&id=745bc008&"
import script from "./TextAlignPopover.vue?vue&type=script&lang=ts&"
export * from "./TextAlignPopover.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports